<template>
  <v-row >
    <v-col >
        <h1 :style="[{color: titleColor}]"  class="font-weight-bold break-word" :class="[titleDisplay, textCenter]">{{ title }}</h1>
    </v-col>
  </v-row>
</template>

<script>
export default {
    name: "AppTitle",
    props: {
        title: {
            type: String,
            required: true
        },
        titleDisplay: {
            type: String,
           default: "display-1",
        },
        textCenter: {
          type: String,
          default: 'text-center'
        },
        titleColor: {
          type: String,
          default: '#1C1E4D'
        }
    }
}
</script>

<style>

</style>